///home/cockskiz/new.greatlysocial.com/frontend/src/pages/dashboard/settings/LogoutPage.js
import { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { UserContext } from '../../../context/UserContext'

// POST /api/auth/logout ends the session (and revokes Bearer tokens); then
// forget the user here too, so protected pages don't render a stale user.
export default function LogoutPage () {
  const nav = useNavigate()
  const { setUser } = useContext(UserContext)

  useEffect(() => {
    ;(async () => {
      try {
        await axios.post('/api/auth/logout', {}, { withCredentials: true })
      } catch (err) {
        console.error('Logout error', err)
      } finally {
        localStorage.removeItem('token')
        setUser({})
        nav('/login', { replace: true })
      }
    })()
  }, [nav, setUser])

  return <p>Logging out…</p>
}
